import { css } from '@emotion/react'

import { MotionCurveStandard } from '@cash-design-system/tokens'

const motion = {
  standardTransition: css`
    transition-property: transform, background, color;
    transition-duration: 80ms;
    transition-timing-function: ${MotionCurveStandard};
  `,
  standardActiveState: css`
    transform: scale(0.95);
  `,
} as const

export type ThemeMotion = typeof motion

export default motion
